import { HomeWeekChartSegment } from 'enums';

export const HOME_WEEK_CHART = {
  DEFAULT_SEGMENT: HomeWeekChartSegment.OVERALL,
  TITLE_KEY: 'weekly_stats.this_week',
  EMPTY_MESSAGE_KEY: 'weekly_stats.no_week_data',
  EMPTY_DESCRIPTION_KEY: 'weekly_stats.no_week_data_description',
  EMPTY_FOCUS_MESSAGE_KEY: 'weekly_stats.no_focus_this_week',
  EMPTY_FOCUS_DESCRIPTION_KEY: 'weekly_stats.no_focus_this_week_description',
  SEGMENTS: [
    {
      value: HomeWeekChartSegment.OVERALL,
      labelKey: 'weekly_stats.segment_overall'
    },
    {
      value: HomeWeekChartSegment.MORNING,
      labelKey: 'weekly_stats.segment_morning'
    },
    {
      value: HomeWeekChartSegment.EVENING,
      labelKey: 'weekly_stats.segment_evening'
    },
    {
      value: HomeWeekChartSegment.FOCUS,
      labelKey: 'weekly_stats.segment_focus'
    }
  ]
} as const;

export const HOME_WEEK_CHART_Y_AXIS_KEY = {
  [HomeWeekChartSegment.OVERALL]: 'weekly_stats.y_axis_percent',
  [HomeWeekChartSegment.MORNING]: 'weekly_stats.y_axis_percent',
  [HomeWeekChartSegment.EVENING]: 'weekly_stats.y_axis_percent',
  [HomeWeekChartSegment.FOCUS]: 'weekly_stats.y_axis_focus_sessions'
} as const;

export const DEFAULT_WEEKLY_STATS_OVERVIEW = {
  TOTAL_FOCUS_SESSIONS: 0,
  TOTAL_FOCUS_HOURS: 0,
  TOTAL_HABITS: 0,
  BEST_DAY_COMPLETION: 0,
  BEST_DAY_LABEL: '--',
  AVERAGE_MORNING: 0,
  AVERAGE_EVENING: 0,
  AVERAGE_OVERALL: 0,
  HABITS_PER_DAY: 0
} as const;
